export enum ConfigGroupKey {
  CUSTOMER_PROPERTY = "CUSTOMER_PROPERTY",
  DATE_TIME_PROPERTY = "DATE_TIME_PROPERTY",
  RECEIPT_DETAIL = "RECEIPT_DETAIL",
  CUSTOM_FIELD = "CUSTOM_FIELD",
}
